import type { InjectionKey, Ref } from 'vue'

import { usePage } from '@inertiajs/vue3'
import { inject, provide, ref, watch } from 'vue'

const PAGE_WIDTH_KEY: InjectionKey<Ref<boolean>> = Symbol('page-width-constrained')

export const providePageWidth = (): Ref<boolean> => {
  const isConstrained = ref(true)
  provide(PAGE_WIDTH_KEY, isConstrained)

  const page = usePage()
  watch(
    () => page.component,
    () => {
      isConstrained.value = true
    }
  )

  return isConstrained
}

export const usePageWidth = () => {
  const isConstrained = inject(PAGE_WIDTH_KEY, null)

  const fullWidth = (): void => {
    if (isConstrained) isConstrained.value = false
  }

  return { fullWidth }
}
